import _ from 'lodash';
import { FETCH_PATIENTS_BY_SEARCH_START, FETCH_PATIENTS_BY_SEARCH_SUCCESS, FETCH_PATIENTS_BY_SEARCH_ERROR, ADD_NEW_PATIENT_SUCCESS, UPDATE_PATIENT_SUCCESS, UPLOAD_PATIENT_DOCUMENT_SUCCESS, UPLOAD_PATIENT_DOCUMENT_ERROR, FETCH_PATIENT_DOCUMENTS_SUCCESS, FETCH_PATIENT_DOCUMENTS_ERROR, FETCH_PATIENT_NOTES_SUCCESS, FETCH_PATIENT_NOTES_ERROR, ADD_UPDATE_PATIENT_NOTES_SUCCESS, DELETE_PATIENT_DOCUMENT_SUCCESS, DELETE_PATIENT_DOCUMENT_ERROR, ADD_NEW_PATIENT_ERROR, ADD_NEW_PATIENT_START, UPDATE_PATIENT_START, UPDATE_PATIENT_ERROR, SET_SELECTED_PATIENT_SUCCESS, RESET_SELECTED_PATIENT, REMOVE_MERGE_PATIENTS } from '../../actions/receptionist/patientsAction';
const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    patients: [],
    patientLoading: false,
    selectedPatient: null
}

const patientsReducer = (state = INIT_STATE, action) => {
    let newState;
    let newPatients;
    let index;

    switch (action.type) {
        case FETCH_PATIENTS_BY_SEARCH_START:
            {
                return { ...state, error: '', message: '', loading: true }
            }

        case ADD_NEW_PATIENT_START:
        case UPDATE_PATIENT_START: {
            return { ...state, error: '', message: '', patientLoading: true }
        }
        case ADD_NEW_PATIENT_ERROR:
        case UPDATE_PATIENT_ERROR: {
            return { ...state, error: '', message: '', patientLoading: false }
        }
        case FETCH_PATIENTS_BY_SEARCH_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, patients: action.patients }
        }
        case FETCH_PATIENTS_BY_SEARCH_ERROR:
            {
                return { ...state, loading: false, error: action.error, message: '' }
            }
        case ADD_NEW_PATIENT_SUCCESS: {
            newState = { ...state };
            newState = _.cloneDeep(state);
            index = state.patients.findIndex(patientItem => patientItem.patientId === action.patient.patientId);
            if (index === -1) {
                newState.patients.push(action.patient);
            } else {
                newState.patients[index] = _.cloneDeep(action.patient);;
            }

            return { ...newState, patientLoading: false };
        }

        case UPDATE_PATIENT_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.selectedPatient = newState.selectedPatient === null ? { ...action.patient } : { ...newState.selectedPatient, ...action.patient }
            return { ...newState, patientLoading: false };
        }

        case UPLOAD_PATIENT_DOCUMENT_SUCCESS: {
            newState = _.cloneDeep(state);
            if (newState.selectedPatient !== null) {
                newState.selectedPatient = _.cloneDeep(action.selectedPatient);
                return newState;
            } else {
                return state;
            }
        }

        case UPLOAD_PATIENT_DOCUMENT_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' }

        }

        case FETCH_PATIENT_DOCUMENTS_SUCCESS: {
            newState = _.cloneDeep(state);
            if (newState.selectedPatient !== null) {
                newState.selectedPatient.documents = _.cloneDeep(action.patientDocuments);
            } else {
                newState.selectedPatient = { documents: _.cloneDeep(action.patientDocuments) };
            }
            return newState;
        }
        case FETCH_PATIENT_DOCUMENTS_ERROR: {
            return { ...state, loading: false, message: '' }

        }

        case FETCH_PATIENT_NOTES_SUCCESS: {
            newState = _.cloneDeep(state);
            if (newState.selectedPatient !== null) {
                newState.selectedPatient.notes = [...action.patientNotes];
            }
            return newState;
        }



        case ADD_UPDATE_PATIENT_NOTES_SUCCESS: {
            newState = _.cloneDeep(state);
            if (newState.selectedPatient !== null) {
                newState.selectedPatient.notes = [...newState.selectedPatient.notes, ...action.patientNotes];
            }
            return newState;
        }

        case FETCH_PATIENT_NOTES_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' }
        }

        case DELETE_PATIENT_DOCUMENT_SUCCESS: {
            newState = _.cloneDeep(state);
            if (newState.selectedPatient !== null) {
                newState.selectedPatient = _.cloneDeep(action.selectedPatient);
                return newState;
            } else {
                return state;
            }
        }

        case DELETE_PATIENT_DOCUMENT_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' }
        }

        case SET_SELECTED_PATIENT_SUCCESS: {
            return { ...state, loading: false, selectedPatient: action.patient }
        }

        case RESET_SELECTED_PATIENT: {
            return { ...state, selectedPatient: null }
        }

        case REMOVE_MERGE_PATIENTS: {
            return { ...state, patients: state.patients.filter(patient=>patient.patientId !== action.toBeDeletedPatientId) }
        }

        

        default:
            return state;
    }
}

export default patientsReducer